import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { verifyDevEnvironment, showDevIndicator } from './environment';

const rootElement = document.getElementById('root');
showDevIndicator();
verifyDevEnvironment().then(() => ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)).catch(error => { rootElement.textContent = `Development environment unavailable: ${error.message}`; });
